<template>
  <div class="feedback-box">
    <div class="feedback-btn" @click="openFeedbackModal">
      <div class="gap-10px d-flex align-items-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M17.212 2.23697C17.2718 2.04908 17.2552 1.84518 17.1659 1.66941C17.0765 1.49365 16.9214 1.36016 16.7344 1.29784C16.5473 1.23552 16.3432 1.24939 16.1662 1.33644C15.9893 1.4235 15.8538 1.57673 15.789 1.76297L15.039 4.01197C14.9791 4.19987 14.9957 4.40377 15.0851 4.57953C15.1745 4.7553 15.3295 4.88879 15.5166 4.95111C15.7037 5.01343 15.9078 4.99956 16.0847 4.9125C16.2617 4.82545 16.3972 4.67222 16.462 4.48597L17.212 2.23697ZM21.78 2.21997C21.9204 2.3606 21.9993 2.55122 21.9993 2.74997C21.9993 2.94872 21.9204 3.13935 21.78 3.27997L19.28 5.77997C19.2113 5.85366 19.1285 5.91276 19.0365 5.95375C18.9445 5.99475 18.8452 6.01679 18.7445 6.01856C18.6438 6.02034 18.5438 6.00182 18.4504 5.9641C18.357 5.92637 18.2722 5.87023 18.2009 5.79901C18.1297 5.72779 18.0736 5.64296 18.0359 5.54957C17.9981 5.45618 17.9796 5.35615 17.9814 5.25545C17.9832 5.15475 18.0052 5.05543 18.0462 4.96343C18.0872 4.87144 18.1463 4.78863 18.22 4.71997L20.72 2.21997C20.8606 2.07952 21.0512 2.00063 21.25 2.00063C21.4487 2.00063 21.6394 2.07952 21.78 2.21997ZM9.07598 4.31797C9.24006 3.97726 9.48478 3.68172 9.7889 3.45696C10.093 3.23221 10.4474 3.08503 10.8212 3.02819C11.1951 2.97134 11.5772 3.00655 11.9344 3.13076C12.2916 3.25497 12.6131 3.46443 12.871 3.74097L19.877 11.247C20.13 11.518 20.3144 11.8457 20.415 12.2025C20.5156 12.5594 20.5294 12.9352 20.4552 13.2984C20.381 13.6617 20.221 14.002 19.9886 14.2908C19.7561 14.5797 19.458 14.8088 19.119 14.959L15.699 16.475C16.1149 17.4426 16.1324 18.5352 15.7477 19.5156C15.363 20.4961 14.6072 21.2852 13.6442 21.7118C12.6812 22.1384 11.5889 22.168 10.6043 21.7941C9.61962 21.4203 8.82217 20.6732 8.38498 19.715L6.96798 20.343C6.6439 20.4866 6.28464 20.5313 5.93525 20.4715C5.58586 20.4117 5.26189 20.2501 5.00398 20.007L3.56498 18.65C3.28676 18.3877 3.09928 18.0437 3.02969 17.6677C2.96011 17.2918 3.01205 16.9034 3.17798 16.559L9.07598 4.31797ZM9.75798 19.107C10.0403 19.691 10.5385 20.1424 11.1474 20.3659C11.7564 20.5893 12.4283 20.5674 13.0214 20.3047C13.6144 20.042 14.0822 19.5591 14.3258 18.9579C14.5694 18.3567 14.5698 17.6844 14.327 17.083L9.75698 19.107H9.75798ZM11.774 4.76497C11.6825 4.66695 11.5685 4.5927 11.4419 4.54865C11.3152 4.5046 11.1798 4.49208 11.0472 4.51217C10.9146 4.53226 10.789 4.58436 10.6811 4.66396C10.5732 4.74355 10.4863 4.84824 10.428 4.96897L4.52998 17.21C4.50215 17.2674 4.49335 17.3322 4.50486 17.3949C4.51637 17.4577 4.54759 17.5152 4.59398 17.559L6.03298 18.915C6.07594 18.9554 6.12987 18.9823 6.18804 18.9923C6.2462 19.0022 6.30601 18.9948 6.35998 18.971L18.511 13.588C18.6313 13.5348 18.7372 13.4536 18.8198 13.3511C18.9023 13.2487 18.9592 13.128 18.9856 12.9991C19.012 12.8702 19.0073 12.7369 18.9717 12.6102C18.9361 12.4835 18.8707 12.3672 18.781 12.271L11.774 4.76497ZM19 8.24897C19 8.05006 19.079 7.85929 19.2197 7.71864C19.3603 7.57799 19.5511 7.49897 19.75 7.49897H21.75C21.9489 7.49897 22.1397 7.57799 22.2803 7.71864C22.421 7.85929 22.5 8.05006 22.5 8.24897C22.5 8.44788 22.421 8.63865 22.2803 8.7793C22.1397 8.91996 21.9489 8.99897 21.75 8.99897H19.75C19.5511 8.99897 19.3603 8.91996 19.2197 8.7793C19.079 8.63865 19 8.44788 19 8.24897Z" fill="#E8EAED"/>
      </svg>
      {{ 'Give us your Feedback' | trans }}
      </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";
import { EventBus } from '../../events/event.bus';
import { OPEN_FEEDBACK_MODAL } from '../../events/app.events';

export default {
  name: "Feedback",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    openFeedbackModal() {
      EventBus.$emit(OPEN_FEEDBACK_MODAL, {});
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.feedback-box {
  width: 100%;
  display: flex;
  .feedback-btn {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 10px 20px !important;
    justify-content: space-between;
    width: max-content;
    gap: 10px;
    border-radius: 4px;
    border: 1px solid #595959;
    background: #333;
    cursor: pointer;


    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
